import { Table } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

export const styles = /* istanbul ignore next */ () => ({
  root: {
    margin: [[20, 0]],
  },
});

export default withStyles(styles)(Table);
